import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77acd678")

_pushScopeId("data-v-77acd678")
const _hoisted_1 = { class: "d-flex flex-column gap-4 justify-content-center" }
const _hoisted_2 = { class: "big-number" }
const _hoisted_3 = { class: "unit text-muted" }
_popScopeId()



export default _defineComponent({
  props: {
    values: Array<any>
},
  setup(__props) {

const props = __props

const formatNumber = (value: number, isInteger: boolean|null = null) => {
    if (value >= 1_000_000) {
        return (isInteger ? Math.round(value / 1_000_000) : (value / 1_000_000).toFixed(1)) + 'M';
    } else if (value >= 1_000) {
        return (isInteger ? Math.round(value / 1_000) : (value / 1_000).toFixed(1)) + 'k';
    }
    return value.toFixed(1).toString();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(props.values, (value) => {
      return (_openBlock(), _createBlock("div", {
        key: value.label,
        class: "number-container"
      }, [
        _createVNode("div", null, _toDisplayString(value.label), 1),
        _createVNode("div", null, [
          _createVNode("span", _hoisted_2, _toDisplayString(formatNumber(value.value)), 1),
          _createVNode("span", _hoisted_3, _toDisplayString(value.unit), 1)
        ])
      ]))
    }), 128))
  ]))
}
}

})